export const ROLES = ['read', 'editor', 'admin'];

const ROLE_RANK = { read: 1, editor: 2, admin: 3 };

export function roleRank(role) {
  return ROLE_RANK[role] || 0;
}

export function maxRole(a, b) {
  return roleRank(a) >= roleRank(b) ? a : b;
}

export function effectiveRole(grants, userId) {
  let role = null;
  for (const g of grants || []) {
    if (g.user_id === userId) {
      role = role ? maxRole(role, g.role) : g.role;
    }
  }
  return role;
}

export function addGrant(grants, grant) {
  const isMatch = (g) =>
    g.user_id === grant.user_id &&
    g.source === grant.source &&
    (g.folder_path || null) === (grant.folder_path || null);
  const next = (grants || []).filter((g) => !isMatch(g));
  next.push(grant);
  return next;
}

export function removeGrants(grants, predicate) {
  return (grants || []).filter((g) => !predicate(g));
}

export function rederiveSharedWith(grants) {
  const set = new Set();
  for (const g of grants || []) set.add(g.user_id);
  return Array.from(set);
}

export function applyFolderGrantsToFile(fileGrants, folderGrants, folderPath) {
  let next = fileGrants || [];
  for (const fg of folderGrants || []) {
    next = addGrant(next, {
      user_id: fg.user_id,
      role: fg.role,
      source: 'folder',
      folder_path: folderPath,
    });
  }
  return next;
}

export function stripFolderGrantsFromFile(fileGrants, folderPath, userId = null) {
  return removeGrants(fileGrants, (g) =>
    g.source === 'folder' &&
    g.folder_path === folderPath &&
    (userId === null || g.user_id === userId)
  );
}
